import { useEffect, useState } from 'react';

interface UserAvatarProps {
  /** Image URL; falls back to the name's first letter when absent or broken. */
  src?: string | null;
  /** Display name; provides the fallback initial and the image alt text. */
  name: string;
  /**
   * Size + colour classes for the circle, e.g.
   * "h-8 w-8 bg-primary-100 text-sm text-primary-600".
   * The fallback initial inherits the text classes from the container.
   */
  className?: string;
}

/**
 * Round user avatar: renders the profile image when a URL is available and
 * loadable, otherwise the first letter of the name.
 */
export function UserAvatar({ src, name, className = '' }: UserAvatarProps) {
  const [failed, setFailed] = useState(false);
  // Retry when the URL changes (e.g. after a new photo is uploaded).
  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <div
      className={`flex items-center justify-center overflow-hidden rounded-full ${className}`}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={name}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <span>{(name.charAt(0) || 'U').toUpperCase()}</span>
      )}
    </div>
  );
}

export default UserAvatar;
